import React from 'react';
import { withTranslation } from 'react-i18next';
import { ToastContainer, notify } from '../libraries/notifications';
import config from '../config';
import { isEmptyObject } from '../libraries/utils';

import LayoutResponsive from '../components/layout/LayoutResponsive';
import NavButtonBar from '../components/commons/NavButtonBar';
import BottomNav from '../components/commons/BottomNav';
import Feed from './home/Feed';
import Offer from './home/Offer';
import Initiatives from './home/Initiatives';
import Actions from './home/Actions';
import Benefits from './home/Benefits';
import Prizes from './home/Prizes';
import Ranking from './home/Ranking';
import { connect } from 'react-redux';
import settingsActions from '../context/settings/actions';
import { history } from '../routes';
import Swal from 'sweetalert2';
import actions from '../context/users/actions';
import { differenceInDays, formatDistance, isBefore } from 'date-fns';
import { startOfDay } from 'date-fns';
import Slider from './commons/Slider';
import Loader from '../components/commons/Loader';

class Home extends React.Component {
  constructor(props) {
    super(props);
    this.t = this.props.t;
    this.state = {
      topNav: config.ROUTES.MAIN.FEED,
      bottonNav: config.ROUTES.HOME,
      buttonBarUpper: [],
      appMode: this.props?.mode_app_settings?.item?.value || "normal",
      valideElFlujo: false,
      sliders: null,
    }
  }

  async componentDidMount() {
    await this.get_event_setting();
    await this.getSettingSharyco()
    await this.getSettings();
    await this.userToken();
    if (!isEmptyObject(this.props.location.state)) {
      const { from } = this.props.location.state;
      this.setState({ topNav: from, from });
    }
  }
  componentDidUpdate(prevProps, prevState) {
    console.log("UpDATED==========")
    //   debugger
    //   if(this.props.mode_app_settings.item !== prevProps.mode_app_settings.item){
    //     const modoapp= this.props.mode_app_settings.item?.value || "normal"
    //       this.setState({slider:localStorage.getItem(config.SLIDER_SCREEN)? JSON.parse(localStorage.getItem(config.SLIDER_SCREEN)) : config.SLIDER.normal.SHOW})
    //  }
  }

  userToken = async () => {
    await this.props.onGetToken();
    if (this.state.show_onboarding) {
      this.validarFlujo()
    }
  }

  validarFlujo = async () => {
    // Si el usuario omitió el onboarding en esta sesión, no lo redirigimos al flow (evita loop).
    if (sessionStorage.getItem(config.ONBOARDING_SKIPPED)) {
      this.setState({ valideElFlujo: true })
      return
    }
    const appmode = this.state.appMode.value || "normal"
    const arraysFlows = config.FLOWS[appmode] ?? config.FLOWS["normal"];
    const array = this.props.auth.user?.tour?.split(',') ?? ["0"];
    const quantityUserFlows = array.length

    if (quantityUserFlows !== arraysFlows.length) {
      const arrayTourFlows = Array(arraysFlows.length).fill(0).join(",")
      const dataUser = {
        id: this.props.auth.user.id,
        tour: arrayTourFlows
      }
      await this.props.onSaveOrUpdatedUser(dataUser)
      await this.userToken()
      this.setState({ valideElFlujo: true })
      return
    }
    if (!this.props.auth.user?.tour) {
      const idFlow = arraysFlows[0].id
      this.setState({ valideElFlujo: true })
      return history.push(config.ROUTES.FLOW.STEP1.replace(':id', idFlow)); //config.ROUTES.HOME
    } else {
      // console.log("=======================")
      // 'this.props.auth.user?.tour' es una cadena que contiene fechas separadas por comas
      const array = this.props.auth.user?.tour.split(',');
      const quantityUserFlows = array.length
      // console.log(array)
      const index = array.indexOf('0');
      if (index < 0) {
        console.log(`Index= ${index} ya hizo todos los flows goHome`);
        this.setState({ valideElFlujo: true })
        return history.push(config.ROUTES.HOME);
      }
      // debugger
      const idFlow = arraysFlows[index]?.id;

      // Obtener la fecha del último flujo
      const fechaUltimoFlowHecho = array[index - 1];
      const fecha = new Date(fechaUltimoFlowHecho);
      const hoy = startOfDay(new Date())
      const distanciaEnDias = differenceInDays(hoy, fecha)

      console.log("Fecha Ultimo flow ", fecha)
      console.log("Fecha de hoy  ", hoy)
      console.log("Diferencia en dias de ultFlow y hoy  ", distanciaEnDias)
      console.log("Configuracion dias x flow", this.state.timeBetweenFlows)
      console.log("=======================")
      const esInvalida = isNaN(fecha.getTime());
      if (this.state.timeBetweenFlows === 0 || esInvalida) {
        console.log(`Tiempo entre flows = ${this.state.timeBetweenFlows} goFlow`);
        this.setState({ valideElFlujo: true })
        return history.push(config.ROUTES.FLOW.STEP1.replace(':id', idFlow));
      }

      if (differenceInDays(hoy, fecha) >= this.state.timeBetweenFlows ||
        (differenceInDays(hoy, fecha) === this.state.timeBetweenFlows - 1 && isBefore(fecha, hoy))
      ) {
        this.setState({ valideElFlujo: true })
        return history.push(config.ROUTES.FLOW.STEP1.replace(':id', idFlow));
      } else {
        this.setState({ valideElFlujo: true })
        return history.push(config.ROUTES.HOME);
      }
    }
  }
  onNavBarClick = (option) => {
    console.log('OPTION', option);
    this.setState({ topNav: option });
  }

  getSettingsValueByCode = (settingsList, code) => {
    let get_false_if_zero = (v) => v === "false" ? false : true
    let setting = settingsList.find(s => s.code === code)
    if (!setting) return false
    return setting ? get_false_if_zero(setting.value) : true
  }

  getSettingSharyco = async () => {
    await this.props.onGetAllSettings({
      "type": "sharyco_admin_settings",
      "owner": "system",
      "code": "tiempo_flows"
    });
    const { settings } = this.props;
    if (settings.error) {
      notify(this.t(settings.error.message));
    } else {
      if (settings.items.length > 0) {
        this.setState({ timeBetweenFlows: Number(settings.items[0].value) })
      } else {
        this.setState({ timeBetweenFlows: 0 })
      }
    }
  }

  get_event_setting = async () => {
    await this.props.onGetEventSettings({
      "type": "sharyco_settings",
      "code": "app_event",
      "owner": this.props.auth.user.unique_id
    });
    const { mode_app_settings } = this.props;
    if (mode_app_settings.error) {
      notify(this.t(mode_app_settings.error.message));
      if (this.state.sliders === null) this.setState({ sliders: true });
    } else {
      const newState = { appMode: mode_app_settings.item };
      if (this.state.sliders === null) {
        const mo = mode_app_settings?.item?.value || "normal";
        const sliderKey = `${config.SLIDER_SCREEN}_${mo}`;
        const alreadySeen = localStorage.getItem(sliderKey) !== null;
        if (alreadySeen) {
          newState.sliders = true;
        } else {
          const shouldShow = config.SLIDER[mo]?.SHOW ?? false;
          newState.sliders = !shouldShow;
        }
      }
      this.setState(newState);
    }
  }

  getSettings = async () => {
    await this.props.onGetAllSettings({ owner: this.props.auth.user.unique_id });
    const { settings } = this.props;
    if (settings.error) {
      notify(this.t(settings.error.message));
    } else {
      let show_offers = this.getSettingsValueByCode(settings.items, "show_offers")
      let show_benefits = this.getSettingsValueByCode(settings.items, "show_benefits")
      let show_actions = this.getSettingsValueByCode(settings.items, "show_actions")
      let show_initiatives = this.getSettingsValueByCode(settings.items, "show_initiatives")
      let show_onboarding = this.getSettingsValueByCode(settings.items, "show_onboarding")
      //let show_prizes = this.getSettingsValueByCode(settings.items, "show_prizes")
      let show_prizes = true

      //show_offers = true
      //show_benefits = true
      //show_actions = true
      //show_initiatives = true

      let options = [...config.BUTTONBAR.UPPER]
      if (!show_offers) options = options.filter(o => o.route !== config.ROUTES.MAIN.OFFER)
      if (!show_benefits) options = options.filter(o => o.route !== config.ROUTES.MAIN.BENEFITS)
      if (!show_actions) options = options.filter(o => o.route !== config.ROUTES.MAIN.ACTIONS)
      if (!show_initiatives) options = options.filter(o => o.route !== config.ROUTES.MAIN.INITIATIVES)
      if (!show_prizes) options = options.filter(o => o.route !== config.ROUTES.MAIN.PRIZES)

      this.setState({
        settings: settings.items,
        show_offers,
        show_benefits,
        show_actions,
        show_initiatives,
        show_prizes,
        show_onboarding,
        buttonBarUpper: options,
      });
      console.log("settings", settings)
      console.log("settings", show_offers)
      console.log("settings", options)
    }
  }

  closeSliders = (sliders) => {
    localStorage.setItem("SLIDER_SCREENS", JSON.stringify(true));
    this.setState({ sliders: sliders })
  }

  render() {
    console.log("RENDER HOME", this.state)
    if (this.state.sliders === null) {
      return <Loader />;
    }
    if (!this.state.sliders) {
      return (<Slider close={() => this.setState({ sliders: true })} />);
    }

    if (!this.state.valideElFlujo) {
      return (
        <LayoutResponsive
          header={{ logo: true, }}
        >
          <ToastContainer />
          <Feed/>
          <BottomNav/>
        </LayoutResponsive>
      )
    }

    // if (this.state.slider && !localStorage.getItem("SLIDER_SCREENS")) {
    //   return (<Slider close={(slider) => this.closeSliders(slider)} />);
    // }

      return (
        <LayoutResponsive
          header={{ logo: true, }}
        >
          <ToastContainer />
          <Feed />
          {/* <BottomNav/> */}

        </LayoutResponsive>
      )
  }
}


const mapStateToProps = state => {
  return {
    auth: state.users.auth,
    settings: state.settings.list,
    mode_app_settings: state.settings.appmode,
  };
};

const mapDispatchToProps = dispatch => {
  return {
    onGetAllSettings: (params) => dispatch(settingsActions.getAll(params)),
    onGetToken: () => dispatch(actions.getFromToken()),
    onGetSetting: (params) => dispatch(settingsActions.getAll(params)),
    onGetEventSettings: (params) => dispatch(settingsActions.getAllEvent(params)),
    onSaveOrUpdatedUser: (params) => dispatch(actions.saveOrUpdate(params)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withTranslation()(Home));

